import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Semiconductor.css';
import OurProductsSection from "./OurProductsSection"
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';


// At the top of Semiconductor.jsx
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import SemiConductorIndustryImg from "../assets/SemiConductorIndustryImg.jpg";
import semiconductor1 from "../assets/semiconductor1.png";
import semiconductor2 from "../assets/semiconductor2.png";
import semiconductor3 from "../assets/semiconductor3.png";
import semiconductor4 from "../assets/semiconductor4.png";
import semiconductor5 from "../assets/semiconductor5.png";
import semiconductor6 from "../assets/semiconductor6.png";
import semiconductor7 from "../assets/semiconductor7.jpg";
import semiconductor8 from "../assets/semiconductor8.png";
import semiconductor9 from "../assets/semiconductor9.png";
import semiconductor10 from "../assets/semiconductor10.png";
import semiconductor11 from "../assets/semiconductor11.png";
import semiconductorpdf from "../assets/2023-semiconductor-solution-AKUSENSE.pdf";



const Semiconductor = () => {
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="Semiconductor">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner5">
        <div className="hero-content">
          <h1>SEMICONDUCTOR</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Semiconductor</span>
          </div>
        </div>
      </section> */}

<section className="semiconductor-hero-clean">
  <div className="hero-text">
    <h1>Semiconductor Industry</h1>
    <p>
      We already serve customers from the semiconductor manufacturing segment in various areas such as wafer handling,
      water processing or carrier handling.
    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={SemiConductorIndustryImg} alt="Semiconductor Industry" />
  </div>
</section>

<section className="semiconductor-content">
{[
  {
    title: "Wafer detection",
    text: "Detect the floating of the wafer to prevent accidents.",
    img: semiconductor1
  },
  {
    title: "Use diffuse reflection photoelectric detection wafer",
    text: "Use diffuse reflection photoelectric detection of wafers to determine the number of wafers.",
    img: semiconductor2
  },
  {
    title: "Detect semiconductor wafers",
    text: "Contact sensors detect semiconductor wafers, µm level detection.",
    img: semiconductor3
  },
  {
    title: "Measuring thickness and flatness of wafer",
    text: "Measuring thickness and flatness of wafer.",
    img: semiconductor4
  },
  {
    title: "Using the IC tester to check out the workpiece",
    text: "Detecting the chip notch on the thin IC.",
    img: semiconductor5
  },
  {
    title: "Detect chip notch",
    text: "Using coaxial reflective fiber and lens to detect small gaps.",
    img: semiconductor6
  },
  {
    title: "Detect chip position",
    text: "The tiny optical fiber can detect the warpage of the tiny chip. The narrow beam projected from the ultra-fine fiber core can identify subtle changes.",
    img: semiconductor7
  },
  {
    title: "Detect whether the wafers are placed accurately",
    text: "Check whether the wafer placement is accurate",
    img: semiconductor8
  },
  {
    title: "Diffuse Type Fiber Optic Components Sensor",
    text: "Frequency State Modulation",
    img: semiconductor9
  },
  {
    title: "Using precision positioning sensor for glass substrate positioning",
    text: "Measuring the basic flatness of glass.",
    img: semiconductor10
  },
  {
    title: "Using cameras to locate lithium batteries",
    text: "Use cameras to locate lithium batteries and detect product defects.",
    img: semiconductor11
  }
].map((item, idx) => (
  <div className={`semiconductor-row ${idx % 2 !== 0 ? 'reverse' : ''}`} key={idx}>
    <div className="semiconductor-image">
      <img src={item.img} alt={item.title} />
    </div>
    <div className="semiconductor-text">
      <h3>{item.title}</h3>
      <p>{item.text}</p>
    </div>
  </div>
))}

</section>

<OurProductsSection />
      <section className="action-buttons-section">
        <a href={semiconductorpdf} target="_blank" rel="noopener noreferrer">
          <button className="download-btn">📄 Download</button>
        </a>
          <button className="quote-btn" onClick={() => setIsModalOpen(true)}>📩 Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      </section>

      <Footer />
    </div>
  );
};
export default Semiconductor;